import {
  AddToCartEvent,
  CartEvent,
  ItemEvent,
  ItemListEvent,
  PurchaseEvent,
  PurchaseMetadataEvent,
} from "../types/analytics-type";
import { ListServicesType, ServiceVariation } from "../types/server";

export function service_to_ga_item(
  service: ListServicesType,
  variation?: ServiceVariation
): ItemEvent {
  let output: ItemEvent = {
    item_id: service.id,
    item_name: service.name,
  };
  if (variation) {
    output.item_variant = variation.name;
  }
  return output;
}

export function services_list_to_ga_item_list(
  list_id,
  list_name,
  services: ListServicesType[]
): ItemListEvent {
  return {
    item_list_id: list_id,
    item_list_name: list_name,
    items: services.map((service) => service_to_ga_item(service)),
  };
}

export function services_to_ga_cart(
  value,
  services: ListServicesType[],
  coupon?: string
): CartEvent {
  let output: CartEvent = {
    currency: "USD",
    value,
    items: services.map((service) => service_to_ga_item(service)),
  };
  if (coupon) {
    output.coupon = coupon;
  }

  return output;
}
export function services_to_ga_purchase(
  value,
  services: ListServicesType[],
  { tax, coupon, shipping, transaction_id, affiliation }: PurchaseMetadataEvent
): PurchaseEvent {
  let output: PurchaseEvent = {
    currency: "USD",
    value,
    items: services.map((service) => service_to_ga_item(service)),
  };
  if (coupon) {
    output.coupon = coupon;
  }
  if (tax) {
    output.tax = tax;
  }
  if (shipping) {
    output.shipping = shipping;
  }
  if (transaction_id) {
    output.transaction_id = transaction_id;
  }
  if (affiliation) {
    output.affiliation = affiliation;
  }

  return output;
}

export function service_as_ga_change_to_cart(
  value,
  service: ListServicesType,
  variation?: ServiceVariation
): AddToCartEvent {
  return {
    currency: "USD",
    value,
    items: [service_to_ga_item(service, variation)],
  };
}
